import React, { useState } from 'react';
import { sendEvent } from '@JohnLewisPartnership/experiments-utils';
import styles from './MobileMenuTabs.scss';

export const MobileMenuTabs = ({ onActiveTabChange }) => {
  const [activeTab, setActiveTab] = useState('Shop');
  const menuItems = [
    { name: 'Shop' },
    { name: 'Brands' },
    { name: 'Services' },
    { name: 'Help' },
  ];

  const handleTabClick = tab => {
    setActiveTab(tab);
    onActiveTabChange(tab);
    if (tab !== 'Shop') {
      sendEvent(`navigation.tab.${tab.toLowerCase()}.click`);
    }
  };

  return (
    <div className={styles.mobileMenuTabs}>
      <ul>
        {menuItems.map(menuItem => (
          <li
            key={menuItem.name}
            className={menuItem.name === activeTab ? styles.activeTab : ''}
          >
            <button onClick={() => handleTabClick(menuItem.name)}>
              {menuItem.name}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};
